import VS from 'constants/ValidationShema';
import InputLimits from 'constants/InputLimits';
import {SELECT_VALUE} from 'constants/VATItems';

const inputLimits = InputLimits.procedure.basicInformation;

export default (demandRealizationTypes, numberAutomated) => {
    return VS.lazy(() => {
        let baseObj = {
            number: VS.any().when("name", {is: (x) => numberAutomated === true, then: VS.any(), otherwise: VS.stringMax(inputLimits.NUMBER)}),
            demandCategoryType: VS.string(),
            name: VS.stringMax(inputLimits.NAME),
            demandRealizationType: VS.string(),
            demandOrderType: VS.string(),
            primaryTenderVariant: VS.any().when("demandRealizationType", {is: (x) => x === 'primary_tender', then: VS.string(), otherwise: VS.any()}),

            estimatedValue: VS.lazy(x => {
                const s = {
                    value: VS.amount(0, false),
                    grossValue: VS.amount(0, false),
                    vatRate: VS.amount(),
                }
                if (x.vatRate === SELECT_VALUE.CANCEL ||
                    x.vatRate === SELECT_VALUE.DIFFRENT_VAT) {
                    s.vatRate = VS.any();
                }
                if (x.vatRate === SELECT_VALUE.OTHER) {
                    return VS.object({
                        ...s,
                        vatRate: VS.any(),
                        vatRateOther: VS.amountMax100()
                    })
                }
                return VS.object(s);
            }),
            realizationGrossValue: VS.amountOptional(0, false),
        }

        return VS.object(baseObj)
    })
}